import { render, staticRenderFns } from "./DashboardQuestion.vue?vue&type=template&id=5f514b18&scoped=true"
import script from "./DashboardQuestion.vue?vue&type=script&lang=ts"
export * from "./DashboardQuestion.vue?vue&type=script&lang=ts"
import style0 from "./DashboardQuestion.vue?vue&type=style&index=0&id=5f514b18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f514b18",
  null
  
)

export default component.exports